module.exports = __webpack_public_path__ + "static/media/middleToLow.142d11d0.svg";